<template>
  <div class="comment-content">
    <div class="comment__audit-compare-content comment__idea-status">
      <StatusComponent
        v-if="beforeStatus"
        :value="getIdeaStatus(beforeStatus)"
        class="is-opacity"
      />
      <icon
        data="@icon/arrow-to.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--monochrome05to04)"
        class="comment__audit-compare-content__arrow"
      />
      <StatusComponent
        v-if="afterStatus"
        :value="getIdeaStatus(afterStatus)"
      />
    </div>
    <div
      v-if="statusChangeReason"
      class="comment-status-reason"
    >
      <BaseSubHeading
        size="medium"
        weight="400"
      >
        <ReferencedText :html="statusChangeReason" />
      </BaseSubHeading>
    </div>
    <div
      v-if="filesOnly.length"
      class="comment-content__files"
    >
      <div
        v-for="file in filesOnly"
        :key="file.id"
        class="comment-content__file-wrapper"
        :class="{ 'is-deleted': file.deleted }"
      >
        <FileItem
          :file="file"
          :files="comment.fileMetadata"
          :projectScoped="projectScoped"
          fancyboxGroup="comment_tab_fancybox"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import FileItem from "@/components/File/FileItem.vue"
import { ReferencedText } from "@/components/Reference"
import StatusComponent from "@/components/StatusComponent/index.vue"

import { Comment } from "@/models"
import { getIdeaStatus } from "@/views/Ideas/constants"

/** History entry for an Idea status change: the before and after statuses, plus the Obsolete reason and files. */
const props = withDefaults(
  defineProps<{
    comment: Comment
    projectScoped?: boolean
  }>(),
  {
    projectScoped: true
  }
)

const beforeStatus = computed(() => props.comment.ideaAuditRecord?.before?.status)
const afterStatus = computed(() => props.comment.ideaAuditRecord?.after?.status)
// Only a manual status change has a reason worth showing; a reactivated Epic or Item shows just the statuses.
const statusChangeReason = computed(() =>
  props.comment.ideaAuditRecord?.change === "status"
    ? (props.comment.structuredDescription?.html ?? "")
    : ""
)
const filesOnly = computed(() => {
  return props.comment.fileMetadata?.filter(file => !file.isImage && !file.isVideo) ?? []
})
</script>
